"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolConfigToJSON = exports.CommunityPoolConfigFromJSONTyped = exports.CommunityPoolConfigFromJSON = void 0;
function CommunityPoolConfigFromJSON(json) {
    return CommunityPoolConfigFromJSONTyped(json, false);
}
exports.CommunityPoolConfigFromJSON = CommunityPoolConfigFromJSON;
function CommunityPoolConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'fuelUsdPerToken': json['fuelUsdPerToken'],
        'passUsdStandard': json['passUsdStandard'],
        'passUsdRecent': json['passUsdRecent'],
        'passRecentWindowDays': json['passRecentWindowDays'],
        'fuelEligibilityThreshold': json['fuelEligibilityThreshold'],
        'featureEnabled': json['featureEnabled'],
        'allowOnChainSelfAttest': json['allowOnChainSelfAttest'],
    };
}
exports.CommunityPoolConfigFromJSONTyped = CommunityPoolConfigFromJSONTyped;
function CommunityPoolConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'fuelUsdPerToken': value.fuelUsdPerToken,
        'passUsdStandard': value.passUsdStandard,
        'passUsdRecent': value.passUsdRecent,
        'passRecentWindowDays': value.passRecentWindowDays,
        'fuelEligibilityThreshold': value.fuelEligibilityThreshold,
        'featureEnabled': value.featureEnabled,
        'allowOnChainSelfAttest': value.allowOnChainSelfAttest,
    };
}
exports.CommunityPoolConfigToJSON = CommunityPoolConfigToJSON;
